import React, { Component } from 'react';

import './Notes.css';
import ListNotes from './ListNotes';
import EditNote from './EditNote';
import AddNote from './AddNote';

class NotesForm extends Component {

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    render() {
        return (<>
            {(this.props.justAdd == null || !this.props.justAdd) && this.props.notes.map((row, rowIndex) => (
                <div key={row.linkedID}>
                    {this.props.editID !== row.linkedID ? (
                        <ListNotes {...this.props} row={row}
                            handleEditSwap={this.props.handleEditSwap}
                            handleDelete={this.props.handleDelete}
                        />
                    ) : (
                        <EditNote {...this.props} row={row}
                            handleEditSwap={this.props.handleEditSwap}
                            changeComment={this.props.changeComment}
                            handleEditSubmit={this.props.handleEditSubmit}
                            isFormBlank={this.isFormBlank}
                        />
                    )
                    }
                    {(rowIndex < this.props.notes.length - 1) ? <hr className='border-dark' /> : <></>}
                </div>
            ))}
            {((this.props.justAdd)) ? (
                <AddNote {...this.props}
                    handleAddSubmit={this.props.handleAddSubmit}
                    setComment={this.props.setComment}
                    handleCancel={this.props.handleCancel}
                    displayCategories={this.props.displayCategories}
                    addCategoryCommentsArray={this.props.addCategoryCommentsArray}
                    editCategoryCommentsArray={this.props.editCategoryCommentsArray}
                    isFormBlank={this.isFormBlank}
                />
            ) : (<></>)}

        </>
        );

    }

}

export default NotesForm;
